// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1biQ1","actionsCol":"EnrolledClinics_actionsCol__3-pcd"};